/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import { SERVER_URL } from "../../../App";
import LoadingButton from "../../atoms/loadingButton";

type setPasswordResetForm = {
  token: any;
  // email: any;
  onSubmit: any;
  type: "subordinate" | "superadmin";
  // encryptionKey: any;
};

function SetPasswordForm({ token, onSubmit, type }: setPasswordResetForm) {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [twoFAEmail, setTwoFAEmail] = useState("");
  const [errorMessage, setErrormessage] = useState("");

  function submitForm() {
    let url;
    // If no encryption key, this is a manager's account
    if (type === "superadmin") {
      url = SERVER_URL + "/atticaccounts/SetSuperAdminPassword";
      // If there is an encryption key, this is a users's account
    } else {
      url = SERVER_URL + "/atticaccounts/SetUserPassword";
    }

    // Email validation
    const emailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(twoFAEmail);
    if (!emailFormat) {
      setErrormessage("Not a valid email address.");
      return Promise.reject(new Error("Not a valid email address."));
    }

    // All fields must have data
    if (password1 === "" || password2 === "") {
      setErrormessage("No fields can be blank");
      return Promise.reject(new Error("No field can be blank"));
    }

    // Password Validation
    const passLength = password1.length > 12 ? true : false;
    const passSpecialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const passSymbols = passSpecialChars.test(password1);
    const passNumber = /\d+/.test(password1);
    const passCapital = /[A-Z]/.test(password1);

    if (!passLength || !passCapital || !passNumber || !passSymbols) {
      setErrormessage("Passwords must be at least 12 charactors, and include numbers, capitals, and symbols.");
      return Promise.reject(
        new Error("Passwords must be at least 12 charactors, and include numbers, capitals, and symbols."),
      );
    } else if (password1 !== password2) {
      setErrormessage("The passwords don't match.");
      return Promise.reject(new Error("The password's don't match."));
    }

    return fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        password: password1,
        twoFAEmail: twoFAEmail,
      }),
    })
      .then((res) => {
        const data: any = res.json();
        return data;
      })
      .then((data) => {
        if (data["success"]) {
          onSubmit();
          return Promise.resolve();
        } else {
          setErrormessage(data["msg"]);
          return Promise.reject(new Error(data["msg"]));
        }
      });
  }

  return (
    <div>
      <div className="form-cont">
        <h2>Complete your Attic account</h2>
        <input
          type="password"
          autoComplete="off"
          placeholder="Password"
          onChange={(event) => setPassword1(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && document.getElementById("set-password")?.click()}
          value={password1}
        />
        <input
          type="password"
          autoComplete="off"
          placeholder="Confirm Password"
          onChange={(event) => setPassword2(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && document.getElementById("set-password")?.click()}
          value={password2}
        />
        <input
          type="text"
          autoComplete="email"
          placeholder="Recovery Email (Not Work Email)"
          autoCapitalize="off"
          onKeyDown={(event) => event.key === "Enter" && document.getElementById("set-password")?.click()}
          onChange={(event) => setTwoFAEmail(event.target.value)}
          value={twoFAEmail}
        />

        <LoadingButton id="set-password" text="Set Password" onClick={submitForm} />

        <div className="form-error-cont" style={{ padding: 0 }}>
          <p className="error-txt">{errorMessage}</p>
        </div>
      </div>
    </div>
  );
}

export default SetPasswordForm;
